import { RoleType } from '@app-types/enums/role-type';
import { FilterFields, Roles, SendingState } from '@app-types/common';
import { MailAccountSearchOrder } from '@app-types/enums/MailAccountSearchOrder';
import { EmailColumnsEnum } from '@app-types/enums/emailColumns';
import { EmailActionsEnum } from '@app-types/enums/EmailActions';
import { EmailState } from '@app-types/enums/email-state';

export const LOCALE_IDS = [
  {
    language: 'English',
    id: 'en',
  },
  {
    language: 'Deutsch',
    id: 'de',
  },
  {
    language: 'Italiano',
    id: 'it',
  },
  {
    language: 'Français',
    id: 'fr',
  },
];

export const YES_NO_OPTIONS = [
  {
    label: 'no',
    id: false,
  },
  {
    label: 'yes',
    id: true,
  },
];

export const MENU_STATE = [
  {
    title: 'active',
    field: 'isActive',
    value: true,
    fieldRemove: 'isConfigurationCompleted',
  },
  {
    title: 'notActive',
    field: 'isActive',
    value: false,
    fieldRemove: 'isConfigurationCompleted',
  },
  {
    title: 'notConfigured',
    field: 'isConfigurationCompleted',
    value: false,
    fieldRemove: 'isActive',
  },
];

export const MAIL_ACCOUNT_ID = 'mailAccountId';

export const STORAGE_NAMES = {
  CLIENT_ID: 'clientId',
  PRE_RELEASE: 'preRelease',
  USER_LOCALE: 'userLocale',
  SELECTED_ORGANISATION: 'selectedOrganization',
  AUTH_TYPE: 'authType',
  SEARCH_TYPE: 'searchType',
  PAGE_SIZE: 'pageSize',
  PAGE_SIZE_SETTINGS: 'pageSizeSettings',
  SHOW_ADVANCED_SETTINGS: 'showAdvancedSettings',
  SORT_EMAILS: 'sortEmails',
};

export const EMAILS_SETTINGS = {
  PAGE_SIZE: 100,
  STEP_FETCH: 125,
};

export const SETTING_SETTINGS = {
  PAGE_SIZE: 100,
  STEP_FETCH: 100,
};

export const USER_ROLE = {
  RTA: 'RTA',
  ROOT: 'Root',
  USER: 'Default',
};

export const EMAIL_QUERY_PARAM = 'mail';

export const ROLES: Roles[] = [
  {
    name: 'User',
    value: RoleType.User,
  },
  {
    name: 'SuperUser',
    value: RoleType.SuperUser,
  },
  {
    name: 'Creator',
    value: RoleType.Creator,
  },
  {
    name: 'Validator',
    value: RoleType.Validator,
  },
  {
    name: 'LimitedUser',
    value: RoleType.LimitedUser,
  },
  {
    name: 'LimitedCreator',
    value: RoleType.LimitedCreator,
  },
];

export const defaultFilterFields: FilterFields<MailAccountSearchOrder> = {
  ProviderId: null,
  isActive: null,
  isArchive: null,
  searchOrder: 1,
  orderDirection: 1,
};

export const defaultFilter = {
  searchOrder: 1,
  orderDirection: 1,
};

export const SHOWING_CONDITIONS = [
  { header: 'subject', paramName: 'subject' },
  { header: 'from', paramName: 'from' },
  { header: 'to', paramName: 'to' },
  { header: 'cc', paramName: 'cc' },
  { header: 'bcc', paramName: 'bcc' },
  { header: 'body', paramName: 'body' },
];

export const ListOfPossibleLanguages = ['en', 'de', 'it', 'fr'];

export const PATH_ARCHIVE_FTP = 'TX\\PECMAN\\CONS';

export const EMAILS_MENU_SORT = [
  {
    title: 'name',
    id: 'mailAccountEmail',
  },
  {
    title: 'date',
    id: 'creationDateTime',
  },
];

export const TAGS_EXAMPLE = [
  'Test',
  'Test2',
  'Test3',
  'Test4',
  'Test5',
  'Test6',
  'Test7',
  'Test8',
  'Test9',
];
export const GROUPS_EXAMPLE = [
  'Group Test',
  'Group Test2',
  'Group Test3',
  'Group Test4',
  'Group Test5',
  'Group Test6',
  'Group Test7',
  'Group Test8',
  'Group Test9',
];

export const TAGS_COLORS = {
  grey: '#666666',
  blue: '#1E5AEF',
  red: '#E61919',
  yellow: '#F7DC6F',
  green: '#108C1F',
  orange: '#F5A623',
  fuchsia: '#FF00CC',
  azure: '#4AA8F6',
};

export const MAILS_COLUMNS = Object.values(EmailColumnsEnum);

export const MAIL_ACTIONS = Object.values(EmailActionsEnum);

export const EMAIL_SENDING_STATE: { [key: number]: SendingState } = {
  [EmailState.Delivered]: {
    icon: 'done_all',
    tooltip: 'delivered',
    color: 'primary',
  },
  [EmailState.DeliveryError]: {
    icon: 'clear icon',
    tooltip: 'deliveryError',
    color: 'danger',
  },
  [EmailState.NotAccepted]: {
    icon: 'clear icon',
    tooltip: 'notAccepted',
    color: 'danger',
  },
  [EmailState.Accepted]: {
    icon: 'done',
    tooltip: 'accepted',
    color: 'primary',
  },
  [EmailState.Sent]: {
    icon: 'done',
    tooltip: 'sent',
    color: '',
  },
};

export const MAX_SEARCH = 4;
